import React from "react";
import { CalendarHeart } from "lucide-react";
import { SectionFrame } from "./SectionFrame";
import { StatusBadge } from "../../StatusBadge";

/** Monthly Record - Leave section (spec item 7). Reuses the same immutable leave ledger
 * the Leave tab already reads (leaveApi.employeeLedger) and period-filters it here -
 * opening/closing balances are plain sums of that ledger's own signed `days` field, never
 * a second eligibility/accrual calculation. */
export const LeaveSection = ({ data, period, loading, error, onRetry }) => {
  const ledger = data || [];
  const periodStart = `${period}-01`;
  const periodEnd = `${period}-31`;
  const before = ledger.filter((t) => t.effective_date < periodStart);
  const within = ledger.filter((t) => t.effective_date >= periodStart && t.effective_date <= periodEnd);
  const openingBalance = before.reduce((sum, t) => sum + t.days, 0);
  const closingBalance = openingBalance + within.reduce((sum, t) => sum + t.days, 0);

  return (
    <SectionFrame
      title="Leave" icon={CalendarHeart} testId="monthly-leave-section"
      loading={loading} error={error} onRetry={onRetry}
      isEmpty={within.length === 0}
      emptyMessage="No leave activity recorded for this period."
    >
      <div className="grid grid-cols-2 gap-3 mb-4 text-center">
        <div className="bg-slate-50 rounded-lg p-3"><p className="text-lg font-bold text-slate-900" data-testid="monthly-leave-opening-balance">{openingBalance.toFixed(1)}</p><p className="text-[11px] text-slate-500 uppercase">Opening balance</p></div>
        <div className="bg-slate-50 rounded-lg p-3"><p className="text-lg font-bold text-slate-900" data-testid="monthly-leave-closing-balance">{closingBalance.toFixed(1)}</p><p className="text-[11px] text-slate-500 uppercase">Closing balance</p></div>
      </div>
      {within.map((t) => (
        <div key={t.id} className="flex items-center justify-between py-2 border-t border-slate-100" data-testid={`monthly-leave-row-${t.id}`}>
          <div>
            <p className="text-sm font-medium text-slate-700">{t.effective_date}</p>
            <p className="text-xs text-slate-500">{t.reason || "-"}</p>
          </div>
          <div className="flex items-center gap-2">
            <span className={`text-sm font-semibold ${t.days >= 0 ? "text-emerald-600" : "text-red-500"}`}>{t.days > 0 ? "+" : ""}{t.days}</span>
            <StatusBadge status={t.type} />
          </div>
        </div>
      ))}
    </SectionFrame>
  );
};
